import { create } from 'zustand';

export type CustomsDocumentTypeControl = {
  id: string;
  fileAllowed: boolean;
  translationKey: string;
  validationRegex: RegExp;
  referenceAllowed: boolean;
  displayedToApplicant: boolean;
  categoryTranslationKey: string;
};

type UseCustomsDocumentTypesState = {
  customsDocumentTypes: Map<string, CustomsDocumentTypeControl>;
};

export const useCustomsDocumentTypesState = create<UseCustomsDocumentTypesState>(() => ({
  customsDocumentTypes: new Map(),
}));
